import Bugsnag, { Event } from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import settings from 'helpers/settings';
import { User } from 'types/user';

const APP_VERSION =
  process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA ?? process.env.REACT_APP_VERSION;

const isBrowser =
  typeof window !== 'undefined' && typeof document !== 'undefined';
const isTest = process.env.NODE_ENV === 'test';

// NOOP client to keep API compatible in tests/SSR
const NOOP = {
  notify: (..._args: unknown[]) => undefined,
  addMetadata: (..._args: unknown[]) => undefined,
  setUser: (..._args: unknown[]) => undefined,
  getPlugin: (..._args: unknown[]) => null,
} as any;

export const bugsnagClient =
  isBrowser && !isTest && settings.BUGSNAG_API_KEY
    ? Bugsnag.start({
        apiKey: settings.BUGSNAG_API_KEY,
        plugins: [new BugsnagPluginReact()],
        enabledReleaseStages: ['production', 'staging'],
        appVersion: APP_VERSION,
        releaseStage: process.env.REACT_APP_ENVIRONMENT,
        onError: (event: Event) => {
          const first = event.errors[0];
          const errorClass = first?.errorClass;
          const errorMessage = first?.errorMessage || '';

          if (
            errorClass === 'ChunkLoadError' ||
            errorMessage.includes('Loading CSS chunk')
          ) {
            window.location.reload();
            return false;
          }

          return true;
        },
      })
    : NOOP;

export const updateBugsnagUser = (user?: User) =>
  bugsnagClient.setUser(user ? user.id : undefined);
